import { Filter } from '../models/Filter';

export const appendFilter = (value, label: string, key: string, currentFilters: Filter[], operator?: string) => {
    if (value !== undefined) {
        const newFilter: Filter = {
            operator,
            label,
            key,
            options: [{ label: value ?? '', value: value }],
            selected: [{ label: value ?? '', value: value }]
        }

        return currentFilters ? currentFilters.concat([newFilter]) : [newFilter];;
    }
    else {
        return currentFilters;
    }
}
